import React from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom';
// c:\xampp\htdocs\miners-market-main\pages\PasswordResetPage.js

export default function PasswordResetPage() {
    const navigate = useNavigate();
    const searchParams = useSearchParams()[0];
    const token = searchParams.get('token');

    const [formData, setFormData] = React.useState({
        password: '',
        confirm_password: ''
    });
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(null);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        setIsLoading(true);

        if (formData.password !== formData.confirm_password) {
            setError('Passwords do not match.');
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch('/api/reset_password.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, token })
            });
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'Failed to reset password.');
            }
            setSuccess(result.message);
            setTimeout(() => navigate('/'), 3000); // Redirect to home to log in
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="text-center py-10 text-red-500">
                Invalid password reset link. Please request a new one.
            </div>
        );
    }

    return (
        <div data-name="password-reset-page" data-file="pages/PasswordResetPage.js" className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Set a New Password
                    </h2>
                </div>

                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm">{error}</div>}
                {success && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-sm">{success}</div>}

                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="password" className="sr-only">New Password</label>
                            <input id="password" name="password" type="password" required value={formData.password} onChange={(e) => setFormData(p => ({...p, password: e.target.value}))} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="New Password" />
                        </div>
                        <div>
                            <label htmlFor="confirm_password" className="sr-only">Confirm New Password</label>
                            <input id="confirm_password" name="confirm_password" type={showPassword ? 'text' : 'password'} required value={formData.confirm_password} onChange={(e) => setFormData(p => ({...p, confirm_password: e.target.value}))} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Confirm New Password" />
                        </div>
                    </div>

                    <div>
                        <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white primary-gradient hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50">
                            {isLoading ? 'Resetting...' : 'Reset Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
